import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useMediaQuery } from "@mui/material";
import { Helmet } from "react-helmet-async";

const Payoff = () => {
  const navigate = useNavigate();
  const [value, setValue] = useState(""); // Holds the selected amount
  const [active, setActive] = useState(null); // Active selection index
  const [progress, setProgress] = useState(20);

  const isSmallScreen = useMediaQuery("(max-width:576px)");

  const categories = [
    { name: "Less than Rs. 1,00,000", maxValue: "50000" },
    { name: "Rs. 1,00,000 - 5,00,000", maxValue: "200000" },
    { name: "Rs. 5,00,000 - Rs. 10,00,000", maxValue: "500000" },
    { name: "Rs. 10,00,000 - Rs. 25,00,000", maxValue: "1000000" },
    { name: "More than Rs. 25,00,000", maxValue: "2500000" },
  ];

  // Load selected category from localStorage on mount
  useEffect(() => {
    const storedValue = localStorage.getItem("moneyneed");
    if (storedValue) {
      setValue(storedValue);
      const index = categories.findIndex(
        (category) => category.maxValue === storedValue
      );
      setActive(index); // Highlight the previously selected category
    }
  }, []);

  const handleCategorySelect = (category, index) => {
    setActive(index);
    setValue(category.maxValue);

    localStorage.setItem("moneyneed", category.maxValue);
  };

  useEffect(() => {
    const storedValue = localStorage.getItem("moneyneed");
    if (storedValue) {
      setValue(storedValue);
    } else {
      setActive(0);

      setValue("50000");
      localStorage.setItem("moneyneed", "50000");
    }
  }, []);

  return (
    <>
      <Helmet>
        <title>Select Payoff Loan - Minemi</title>{" "}
      </Helmet>
      <div className="progress-bar-background" />
      <div className="progress-bar" style={{ width: `${progress}%` }} />
      <div className="container">
        {/* Title */}
        <div className="question-title mt-4">How much money do you need?</div>

        {/* Buttons */}
        <div
          className="mt-4"
          style={{
            display: "flex",
            flexDirection: isSmallScreen ? "column" : "row",
            gap: 16,
            justifyContent: "center",
            alignItems: "center",
            margin: "auto",
            flexWrap: "wrap",
          }}
        >
          {categories.map((category, index) => (
            <div
              key={index}
              className={`category-button  ${active === index ? "active" : ""}`}
              onClick={() => handleCategorySelect(category, index)}
              style={{
                marginBottom: "4%",
                fontFamily: "Archivo",
                fontSize: 16,
                fontWeight: 400,
                width: isSmallScreen ? "100%" : "300px",
              }}
            >
              {category.name}
            </div>
          ))}
        </div>

        {/* Next Button */}
        <div
          className="next-button"
          style={{ fontFamily: "Archivo" }}
          onClick={() =>
            // navigate("/select-assets", { state: { moneyneed: value } })
            navigate("/select-prefer", { state: { moneyneed: value } })
          }
        >
          NEXT
        </div>
      </div>
    </>
  );
};

export default Payoff;
